(() => {
  'use strict';
  if (window.__rdcVisitTracker || window.Shopify?.designMode || navigator.webdriver || /bot\b|crawl|spider|headless|lighthouse|pagespeed|preview|facebookexternalhit|slurp|curl|wget|python|httpclient|go-http|selenium|phantomjs|playwright|puppeteer|scrapy|monitor|uptime|pingdom/i.test(navigator.userAgent)) return;
  window.__rdcVisitTracker = true;
  const endpoint = 'https://rdc-visits.proud-fog-2ecf.workers.dev/hit';
  const entry = new URL(location.href);
  const testVisit = entry.searchParams.get('rdc_test')==='1';
  const storageKey = testVisit ? 'rdc_test_visit_v1' : 'rdc_visit_v1';
  let referrer = '', googleSurface='',referrerApp='';
  try {
    const r=new URL(document.referrer);
    if(['https:','http:'].includes(r.protocol)) referrer=r.origin;
    if(/(^|\.)google\.(com|[a-z]{2}|co\.[a-z]{2}|com\.[a-z]{2})$/.test(r.hostname)) {
      googleSurface=/^\/maps(?:\/|$)/.test(r.pathname)?'maps':/^\/search$/.test(r.pathname)?'search':/^\/shopping(?:\/|$)/.test(r.pathname)?'shopping':'';
      if(r.searchParams.get('tbm')==='isch')googleSurface='images';
      if(r.searchParams.get('tbm')==='nws')googleSurface='news';
      if(r.searchParams.get('tbm')==='shop')googleSurface='shopping';
    }
    if(r.protocol==='android-app:') {
      if(/com\.(zhiliaoapp\.musically|ss\.android\.ugc\.(trill|aweme))/.test(r.hostname)) referrerApp='TikTok';
      if(r.hostname==='com.google.android.googlequicksearchbox') referrerApp='Google-app';
    }
  } catch {}
  const product = document.querySelector('[data-rdc-visit-product]')?.getAttribute('data-rdc-visit-product') || '';
  let sent = false, sending = false, human = false, memory, payload;
  let clarityMeta, clarityBound=false, deliveredClarity='',sessionNumber=null,taggedNumber=null;
  const clarityKey=()=>clarityMeta?clarityMeta.userId+'.'+clarityMeta.sessionId:'';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  function tagClarity() {
    if(!allowed() || !Number.isSafeInteger(sessionNumber) || sessionNumber<1 || taggedNumber===sessionNumber || typeof window.clarity!=='function') return;
    try {window.clarity('set','telegram_session','Sessie #'+sessionNumber);taggedNumber=sessionNumber;} catch {}
  }
  function attachClarity() {
    tagClarity();
    if(clarityBound || !allowed() || typeof window.clarity!=='function') return;
    clarityBound=true;
    try {
      window.clarity('metadata',(m,playback)=>{
        if(!allowed() || !playback || m?.projectId!=='yipjdmpz1m' || ![m.userId,m.sessionId].every(v=>typeof v==='string' && /^[a-zA-Z0-9_-]{1,64}$/.test(v))) return;
        clarityMeta={projectId:m.projectId,userId:m.userId,sessionId:m.sessionId};
        if(payload) send();
      },true);
    } catch {clarityBound=false;}
  }
  function session() {
    let saved = memory;
    try { saved = JSON.parse(localStorage.getItem(storageKey)) || saved; } catch {}
    if (!saved?.id || Date.now()-saved.last > 30*60*1000) {
      let seen = false;
      try {seen = !testVisit && Date.now()-Number(localStorage.getItem('rdc_seen_v1')) < 30*86400000;} catch {}
      saved = {id:crypto.randomUUID(),returning:seen};
    }
    saved.last = Date.now(); memory = saved;
    try {localStorage.setItem(storageKey,JSON.stringify(saved));if(!testVisit)localStorage.setItem('rdc_seen_v1',String(Date.now()));} catch {}
    return saved;
  }
  function revoke() {
    try {localStorage.removeItem(storageKey);localStorage.removeItem('rdc_seen_v1');} catch {}
    memory = undefined; payload = undefined; clarityMeta=undefined; clarityBound=false;sessionNumber=null;taggedNumber=null;
  }
  async function send() {
    if (!allowed() || !human || document.visibilityState !== 'visible') return;
    attachClarity();
    if ((sent && deliveredClarity===clarityKey()) || sending) return;
    sending = true;
    if(!payload) {
      const visit = session();
      payload = {session:visit.id,event:crypto.randomUUID(),consent:true,human:true,automated:false,returning:visit.returning,url:entry.origin+entry.pathname,referrer,source:entry.searchParams.get('utm_source') || '',medium:entry.searchParams.get('utm_medium') || '',campaign:entry.searchParams.get('utm_campaign') || '',content:entry.searchParams.get('utm_content') || '',language:navigator.language,screen:innerWidth+' × '+innerHeight,product};
      if(testVisit)payload.test=true;
      payload.clickIds=['ttclid','gclid','gbraid','wbraid','dclid','msclkid','fbclid'].filter(key=>Boolean(entry.searchParams.get(key)));
      payload.googleSurface=googleSurface;payload.referrerApp=referrerApp;payload.term=entry.searchParams.get('utm_term') || '';
      try {payload.timeZone=Intl.DateTimeFormat().resolvedOptions().timeZone;payload.loadMs=Math.round(performance.getEntriesByType('navigation')[0]?.loadEventEnd || 0);} catch {}
    }
    payload.clarity=clarityMeta;
    const submittedClarity=clarityKey();
    try {
      const response = await fetch(endpoint,{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify(payload),keepalive:true,credentials:'omit'});
      sent = response.ok;
      if(sent) deliveredClarity=submittedClarity;
      if(sent && response.status===200) {
        try {sessionNumber=(await response.json()).sessionNumber;tagClarity();} catch {}
      }
    } catch {}
    sending = false;
    if(sent && deliveredClarity!==clarityKey()) send();
  }
  document.addEventListener('visitorConsentCollected',() => {if(allowed()) send(); else revoke();});
  // Wait for a real, trusted input event in a visible tab; passive crawls stay silent.
  for (const type of ['pointerdown','pointermove','touchstart','keydown','scroll']) {
    document.addEventListener(type,event=>{if(event.isTrusted && document.visibilityState==='visible'){human=true;send();}},{passive:true});
  }
  window.addEventListener('online',send);
  document.addEventListener('visibilitychange',() => {if(document.visibilityState==='visible') send();});
  // Retry delivery with the same event/session, without duplicating alerts.
  for(const ms of [3000,10000,30000]) setTimeout(send,ms);
  const ready = () => {
    if(window.Shopify?.customerPrivacy) return send();
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error) send();});
  };
  ready();
  window.addEventListener('load',ready,{once:true});
})();
